/**
 * Labstep
 *
 * @module screens/ResourceLocation/Show
 * @desc ResourceLocation Show Screen
 */

import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { ResourceLocation } from 'labstep-web/models/resource-location.model';
import MasterShow from 'labstep-web/screens/Master/Show';
import { ResourceLocationShowCenter as Center } from 'labstep-web/screens/ResourceLocation/Show/Center';
import { ScreensResourceLocationShowRight as Right } from 'labstep-web/screens/ResourceLocation/Show/Right';
import { isGuid } from 'labstep-web/services/utils.service';
import type React from 'react';
import type {
  IResourceLocationShowScreenContainerProps,
  IResourceLocationShowScreenProps,
} from './types';

export const ResourceLocationShowScreen: React.FC<
  IResourceLocationShowScreenProps
> = ({ resourceLocation }) => (
  <>
    <DocumentHead title={resourceLocation.name} />
    <MasterShow
      entity={resourceLocation}
      center={<Center resourceLocation={resourceLocation} />}
      right={<Right resourceLocation={resourceLocation} />}
    />
  </>
);

export const ResourceLocationShowScreenContainer: React.FC<
  IResourceLocationShowScreenContainerProps
> = ({ match }) => {
  // Detect if path includes id or guid
  // TODO: Remove this once we have migrated the resource location map_data
  const params = isGuid(match.params.id)
    ? { guid: match.params.id }
    : { id: Number(match.params.id) };
  return (
    <ReadOnMountHOC
      type="entities"
      entityName={ResourceLocation.entityName}
      params={{
        get_single: 1,
        is_deleted: 'both',
        ...params,
      }}
      loading={{ loader: 'show' }}
      children={({ entity }) => (
        <ResourceLocationShowScreen resourceLocation={entity} />
      )}
    />
  );
};
